import { z } from "zod";

const count = z.number().int().nonnegative();

export const sourceValueSchema = z.strictObject({
  window_days: z.number().int().positive(),
  items: count,
  eligible: z.strictObject({ total: count, only_here: count, also_elsewhere: count }),
  cost: z.strictObject({ total_usd: z.number().nonnegative(), per_eligible_usd: z.number().nonnegative().nullable() }),
  volume: z.strictObject({ media_hours: z.number().nonnegative(), documents: count }),
  downloads: z.strictObject({ succeeded: count, via_fallback: count, failed: count, failed_href: z.string() }),
  human_work: z.strictObject({ corrections: count, decisions: count, tasks_waiting: count }),
  archive_growth_bytes: count,
  rights: z.array(z.strictObject({ state: z.string(), count })),
  origin_changes: z.array(z.strictObject({ state: z.string(), count })),
});
export type SourceValue = z.infer<typeof sourceValueSchema>;

export const sourceValuesSchema = z.strictObject({
  window_days: z.number().int().positive(),
  sources: z.array(
    z.strictObject({
      source_id: z.string(),
      eligible: count,
      only_here: count,
      cost_usd: z.number().nonnegative(),
      per_eligible_usd: z.number().nonnegative().nullable(),
    }),
  ),
});
export type SourceValues = z.infer<typeof sourceValuesSchema>;
